import {
    fetchGenerateTypes,
    fetchLanguages,
    fetchDeviceProfiles,
    fetchSoundSettings,
    fetchSpecialChars,
    fetchBumps
} from '../api/settings';

import { fetchSwapPartTypes, fetchTextTypes } from '../api/bookparts';

import { fetchSpeakers } from '../api/speakers';

/**
 * @TODOS
 * ? [ ] separate text settings and ssml settings
 *   [x] isolate http requests
 *   ...tbd
 *
 */

const state = {
    languages: [],
    speakers: [],
    types: [],
    textTypes: [],
    deviceProfiles: [],
    bumps: [],
    soundSettings: [],
    //
    specialChars: [],

    //
    swapTypes: []
};

const getters = {
    speakerLanguage: state => lang => {
        const speaker = state.speakers.find(speaker => speaker.slug === lang);
        if (speaker) {
            return speaker.language.slug;
        }
    },
    speakerIdBySlug: state => slug => {
        if (!state.speakers.length) return null;

        const speaker = state.speakers.find(sp => sp.slug === slug);
        if (speaker) {
            return speaker.id;
        }

        return null;
    },
    speakerObject: state => slug => {
        if (!state.speakers.length) return {};

        const speaker = state.speakers.find(sp => sp.slug === slug);
        if (speaker) {
            return speaker;
        }

        return {};
    }
};

const mutations = {
    SET_LANGUAGES(state, languages) {
        state.languages = languages;
    },
    SET_SPEAKERS(state, speakers) {
        state.speakers = speakers;
    },
    SET_TYPES(state, types) {
        state.types = types;
    },
    SET_TEXT_TYPES(state, types) {
        state.textTypes = types;
    },
    SET_DEVICE_PROFILES(state, deviceProfiles) {
        state.deviceProfiles = deviceProfiles;
    },
    SET_BUMPS(state, bumps) {
        state.bumps = bumps;
    },
    SET_SOUND_SETTINGS(state, settings) {
        state.soundSettings = settings;
    },
    SET_SPECIAL_CHARS(state, chars) {
        state.specialChars = chars;
    },
    SET_SWAP_PART_TYPES(state, types) {
        state.swapTypes = types;
    }
};

const actions = {
    async fetchLanguages({ commit }, params) {
        try {
            const { results } = await fetchLanguages(params);
            commit('SET_LANGUAGES', results);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchSpeakers({ commit }, params = {}) {
        try {
            const speakers = await fetchSpeakers(params);
            commit('SET_SPEAKERS', speakers);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchTypes({ commit }) {
        try {
            const response = await fetchGenerateTypes();
            commit('SET_TYPES', response);
        } catch (e) {
            console.log(e);
        }
    },

    async fetchTextTypes({ commit }) {
        try {
            const types = await fetchTextTypes();
            commit('SET_TEXT_TYPES', types);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchDeviceProfiles({ commit }) {
        try {
            const { results } = await fetchDeviceProfiles();
            commit('SET_DEVICE_PROFILES', results);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchBumps({ commit }, filter = 'open,close') {
        try {
            const { results } = await fetchBumps({ audio_type__in: filter });
            commit('SET_BUMPS', results);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchSoundSettings({ commit }) {
        try {
            const { results } = await fetchSoundSettings({ page_size: 1000 });
            commit('SET_SOUND_SETTINGS', results);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchSpecialChars({ commit }) {
        try {
            const chars = await fetchSpecialChars();
            commit('SET_SPECIAL_CHARS', chars);
        } catch (e) {
            console.log(e);
        }
    },
    async fetchSwapPartTypes({ commit }) {
        try {
            const types = await fetchSwapPartTypes();
            commit('SET_SWAP_PART_TYPES', types);
        } catch (e) {
            console.log(e);
        }
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
